import {checkmybusColors as tokensColors} from '@vio/atlas-tokens'

export const colors = {
  ...tokensColors.semantic,
  ...tokensColors.components,
  ...tokensColors.custom
}
